module.exports = __webpack_public_path__ + "img/subheader03_top.c0853c42.jpg";